import React from 'react';
import ErrorRender from "./gd-components/error/error-render";

type Props = {
    style?          : style,
    className?      : string,
    children        : any
}

type State = {
    hasError    : boolean
}

export default class ErrorBoundary extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error: any) {
        return {
            hasError: true
        }
    }

    componentDidCatch(error: any, info: any) {
        console.error("ErrorBoundary componentDidCatch:", error, info)

        // Display fallback UI
        this.setState({ hasError: true })
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, info)
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorRender style={this.props.style} className={this.props.className} />;
        } else if (this.props.children) {
            return this.props.children
        } else return <div/>
    }
}